<span [ngStyle]="getStyle()">{{value}}</span>